import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogClose } from "@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { toast } from "sonner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function DeleteStudentPathwayEnrollment({
    open,
    onOpenChange,
    pathwayId,
    userId,
    studentName,
    onDeleted,
}) {
    const [loading, setLoading] = useState(false);
    const { getToken } = useAuth();

    const handleDelete = async () => {
        setLoading(true);
        try {
            const token = await getToken();
            if (!token) return;
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            };

            // Log what you are sending
            console.log("Deleting pathway enrollment with:", {
                endpoint: `${api_endpoint}/pathway/enrollment/${pathwayId}/${userId}`,
                pathwayId,
                userId,
                studentName,
            });

            await axios.delete(api_endpoint + `/pathway/enrollment/${pathwayId}/${userId}`, reqConfig);
            toast.success(`Student pathway enrollment for "${studentName}" deleted successfully!`);
            setLoading(false);
            onOpenChange(false);
            if (onDeleted) onDeleted(userId);
        } catch (error) {
            console.error("Error deleting student pathway enrollment:", error);
            toast.error(`Failed to delete student pathway enrollment for "${studentName}".`);
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md bg-(--surface-panel) text-(--neutral-900)">
                <DialogHeader>
                    <DialogTitle className="font-heading text-(--neutral-900)">Delete Student Pathway Enrollment</DialogTitle>
                </DialogHeader>
                <div className="font-body text-(--neutral-800)">
                    Are you sure you want to delete <b>{studentName}</b> enrolled in this pathway ? This action cannot be undone.
                </div>
                <div className="mt-4 flex gap-2 justify-between">
                    <DialogClose asChild>
                        <Button
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                            disabled={loading}
                        >
                            Cancel
                        </Button>
                    </DialogClose>
                    <Button
                        variant=""
                        onClick={handleDelete}
                        disabled={loading}
                        className=""
                    >
                        {loading ? (
                            <span className="flex items-center justify-center w-full">
                                <ClipLoader size={20} color="#fff" />
                            </span>
                        ) : (
                            "Delete"
                        )}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}